import * as Icons from '@beamery/lib-ds-icons';
import { useLabel } from '@react-aria/label';
import { mergeProps, useId } from '@react-aria/utils';
import React from 'react';
import { useTheme, useCopy } from '../../hooks/index.js';
import { Action, Content, CloseContainer, CloseButtonElement, Description, IconContainer, Label, NotificationElement, } from './notification.styles.js';
function getStatusIcon(icon) {
    const IconComponent = {
        warning: Icons.Warning,
        success: Icons.Success,
        info: Icons.Info,
        accent: Icons.Sparkle,
    }[icon];
    return IconComponent;
}
function CloseButton({ color, onPress, closeButtonLabel, ...props }) {
    return (React.createElement(CloseButtonElement, { onPress: onPress, ...props },
        React.createElement(Icons.Close, { color: color, title: closeButtonLabel })));
}
var Roles;
(function (Roles) {
    Roles["note"] = "note";
    Roles["status"] = "status";
    Roles["alert"] = "alert";
    Roles["alertdialog"] = "alertdialog";
})(Roles || (Roles = {}));
const getRole = (status, variant) => {
    if (status === 'info' || status === 'accent')
        return Roles.note;
    if (status === 'success')
        return Roles.status;
    if (status === 'warning') {
        if (variant === 'sectionBanner')
            return Roles.note;
        if (variant === 'banner')
            return Roles.note;
        if (variant === 'toast')
            return Roles.status;
    }
    if (status === 'error') {
        if (variant === 'sectionBanner')
            return Roles.status;
        if (variant === 'banner')
            return Roles.alert;
        if (variant === 'toast')
            return Roles.alertdialog;
    }
    return Roles.note;
};
export const Notification = React.forwardRef(({ action, label, description, elementType = 'div', onPressClose, showIcon = true, status = 'info', statusIcon, variant = 'sectionBanner', dataAutomation = 'notification', isOnGray = false, closeButtonLabel, ...rest }, ref) => {
    const theme = useTheme();
    const statusOptions = theme.styles.notifications.status[status];
    const { notification: copy } = useCopy();
    const Icon = statusIcon
        ? Icons[statusIcon]
        : getStatusIcon(statusOptions.icon);
    const descriptionId = useId();
    const { labelProps, fieldProps } = useLabel({
        labelElementType: 'p',
        label,
    });
    return (React.createElement(NotificationElement, { ref: ref, elementType: elementType, variant: variant, status: status, isOnGray: isOnGray, role: getRole(status, variant), "data-automation": dataAutomation, "aria-describedby": description ? descriptionId : undefined, ...mergeProps(fieldProps, rest) },
        showIcon && (React.createElement(IconContainer, null,
            React.createElement(Icon, { color: statusOptions.color, size: 'small' }))),
        React.createElement(Content, { actionPosition: action?.position },
            React.createElement(Label, { id: labelProps.id }, label),
            description ? (React.createElement(Description, { id: descriptionId }, description)) : null,
            action ? (React.createElement(Action, { "data-automation": `${dataAutomation}/action`, ...action })) : null),
        onPressClose && (React.createElement(CloseContainer, null,
            React.createElement(CloseButton, { onPress: onPressClose, color: statusOptions.color, "data-automation": `${dataAutomation}/close`, closeButtonLabel: closeButtonLabel || copy.aria.closeButtonLabel })))));
});
//# sourceMappingURL=notification.component.js.map